module.exports = __webpack_public_path__ + "static/media/megaphone.2c41967c.png";